const getFontSize = theme => {
  return theme.getLength;
};
export { getFontSize as default };